var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "select-link" },
    [
      !_vm.sLink
        ? [
            _c(
              "a",
              {
                staticClass: "choice",
                on: {
                  click: function ($event) {
                    return _vm.handleSelectLink()
                  },
                },
              },
              [_vm._v("选择链接")]
            ),
          ]
        : _c("div", { staticClass: "flex flex-x-between" }, [
            _c("span", { staticClass: "link-title" }, [
              _vm._v(_vm._s(_vm.sLink.title)),
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "choice",
                on: {
                  click: function ($event) {
                    return _vm.handleSelectLink()
                  },
                },
              },
              [_vm._v("修改")]
            ),
          ]),
      _vm._v(" "),
      _c("LinkModal", {
        ref: "LinkModal",
        on: { handleSubmit: _vm.handleSubmit },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }